export enum NavItemLinkType {
  href = 'href',
  uiSref = 'uiSref',
  routerLink = 'routerLink',
  gotoContext = 'gotoContext'
}
